module.exports = __webpack_public_path__ + "img/app st (4).d2b8df43.jpg";